import { Currency } from '@/core/currency/interfaces';

const KWD: Currency = {
    name: 'Kuwaiti Dinar',
    demonym: 'Kuwaiti',
    majorSingle: 'Dinar',
    majorPlural: 'Dinars',
    codeNumeric: '414',
    symbol: 'KD',
    symbolNative: 'د.ك.',
    minorSingle: 'Fils',
    minorPlural: 'Fils',
    ISOdigits: 3,
    decimals: 3,
    numToBasic: 1000,
    code: 'KWD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default KWD;
